import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BasicTable,
  CardComponent,
  Columns,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React, { useEffect, useState } from 'react';
import { PatientCasesMessages } from '../../../core-utils/messages/PatientCasesMessages';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { PatientCasesTabsProps } from '../PatientCasesTabs';
import axios from 'axios';
import properties from '../../../core-utils/properties';
import Loader from '../Loader';
import { formatPatientCasesHistory } from '../../../core-utils/helper-utils/patientCasesHelper';

const PatientCaseHistoryTab: React.FC<
  Omit<PatientCasesTabsProps, 'caseId'>
> = ({ memberId }) => {
  const { classes } = makeStyles()({
    tabContainer: {
      margin: '20px 34px',
    },
  })();

  const messages = PatientCasesMessages;
  const cellStyles = {
    fontSize: '14px',
    lineHeight: '23px',
    color: patientAccessTheme.palette.text.mediumemphasis,
    fontWeight: 400,
    padding: '8px 12px',
  };
  const PatientCaseHistoryColumns: Columns[] = [
    {
      name: 'CASE ID',
      align: 'left',
      cellStyles: cellStyles,
      width: '120px',
      cellPadding: '8px 12px',
    },
    {
      name: 'CREATED',
      align: 'left',
      cellStyles: cellStyles,
      width: '150px',
      cellPadding: '8px 12px',
    },
    {
      name: 'CLOSED',
      align: 'left',
      cellStyles: cellStyles,
      width: '150px',
      cellPadding: '8px 12px',
    },
    {
      name: 'CASE TYPE',
      align: 'left',
      cellStyles: cellStyles,
      width: '150px',
      cellPadding: '8px 12px',
    },
    {
      name: 'TYPE OF TRIGGER',
      align: 'left',
      cellStyles: cellStyles,
      width: '150px',
      showEllipsis: true,
      ellipsisWidth: '150px',
      cellPadding: '8px 12px',
    },
    {
      name: 'REFERREL',
      align: 'center',
      cellStyles: cellStyles,
      width: '100px',
      cellPadding: '8px 12px',
    },
    {
      name: 'ENGAGEMENTS',
      align: 'center',
      cellStyles: cellStyles,
      width: '100px',
      cellPadding: '8px 12px',
    },
  ];

  const [loading, setLoading] = useState<boolean>(false);
  const [casesHistory, setCasesHistory] = useState<any[]>([]);

  const getPatientCaseHistory = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.patientsBaseUrl +
      properties.patientCases;
    const requestBody = {
      patient_id: memberId,
      case_status: 'close',
    };
    return await axios.post(url, requestBody);
  };

  const apiCalls = async () => {
    setLoading(true);
    await Promise.allSettled([getPatientCaseHistory()]).then((responses) => {
      setLoading(false);
      if (responses[0].status === 'fulfilled') {
        setCasesHistory(responses[0].value.data?.data);
      }
    });
    setLoading(false);
  };

  useEffect(() => {
    apiCalls();
  }, []);

  return loading ? (
    <Loader />
  ) : (
    <Grid className={classes.tabContainer}>
      <CardComponent
        title={messages.PATIENT_CASE_HISTORY.TITLE}
        subTitle={messages.PATIENT_CASE_HISTORY.SUBTITLE}
        body={
          <BasicTable
            columns={PatientCaseHistoryColumns}
            rowsData={formatPatientCasesHistory(casesHistory, memberId)}
            width="100%"
            rootStyles={{
              marginTop: '1rem',
              '& .MuiGrid-item': {
                width: '100%',
              },
            }}
            handleHeaderMouseEnter={() => {}}
            handleHeaderMouseLeave={() => {}}
            handleOnClick={() => {}}
          />
        }
      />
    </Grid>
  );
};

export default PatientCaseHistoryTab;
